import React, { useEffect, useState } from 'react'
import styles from './Simulation.module.scss'
import Button from '../../../partials/Button/Button'
import FeedbackBlock from '../../../partials/FeedbackBlock'
import SvgPayload from '../../../partials/SVG/SvgPayload'
import HTMLContent from '../../../partials/HTMLContent'

Array.prototype.random = function () {
    return this[Math.floor((Math.random()*this.length))];
}

const Simulation = (props) => {

    const { data, outcomes, instructions, onBack, onComplete, children } = props
    
    const [outcomeFeedback, setOutcomeFeedback ] = useState()
    /** States */

    useEffect(() =>{
        
        setTimeout(()=>{
            
            const random = ['optimal', 'suboptimal', 'failure'].random()
            setOutcomeFeedback(setOutcome(random))


        },3000)

    },[])

    const setStyle = (outcome) => {
        switch(outcome) {
            case 'optimal': return 'success'
            case 'suboptimal': return 'warning'
            case 'failure': return 'failed'
        }
    }
    const setOutcome = (outcome) => {
        
       return { 
           ...outcomes[outcome], 
           success: outcome === 'optimal',
           style: setStyle(outcome)
       }
    }


    return (
        <div class={styles.simulation}>
            <div className={styles.panel} >
                {outcomeFeedback && 
                        
                    <FeedbackBlock  caption="Scenario" >
                        <HTMLContent html={data.requirements} />
                    </FeedbackBlock>
                    
                }
            </div>
            <div className={styles.panel}>
                <SvgPayload />
                {outcomeFeedback && 

                    <div className={styles.btns}>
                        <Button 
                            text="Retry" 
                            onClick={onBack} 
                            disabled={outcomeFeedback.success} 
                        />  
                        
                        <Button 
                            text="Next" 
                            onClick={onComplete}
                            disabled={!outcomeFeedback.success} 
                        />
                    </div>
                    
                }

            </div>
            <div className={styles.panel} >

                {outcomeFeedback && 
                    
                    <FeedbackBlock 
                        caption={outcomeFeedback.caption} 
                        status={outcomeFeedback.style} >
                            <HTMLContent html={outcomeFeedback.content} />
                    </FeedbackBlock>
                    
                }
                

            </div>
        </div>
    )

}

export default Simulation;